/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'

import { t } from '@/i18n'

import Button from './Button'
import classNames from 'classnames'

interface Props {
  formRef: React.MutableRefObject<HTMLFormElement | null>
  visible?: boolean
  submitting: boolean
  isFormValid: boolean
  onCancel: () => void
  children?: React.ReactNode
  cancelClassName?: string
}

const FormButtons: React.FC<Props> = ({
  formRef,
  visible,
  isFormValid,
  submitting,
  onCancel,
  children,
  cancelClassName,
}) => {
  if (!visible) return null

  return (
    <div className="control-actions">
      <Button
        onClick={onCancel}
        disabled={submitting}
        className={classNames('main-btn white', {
          [cancelClassName || '']: !!cancelClassName,
        })}
      >
        {t('cancel')}
      </Button>
      <Button
        type="button"
        className="main-btn"
        disabled={!isFormValid || submitting}
        onClick={() =>
          formRef.current?.dispatchEvent(
            new Event('submit', { cancelable: true, bubbles: true }),
          )
        }
      >
        {t('save_changes')}
      </Button>
      {children}
    </div>
  )
}

export default FormButtons
